import { api } from "@/api";
import { ApiResponseType, PostCenterSignUpRequst, PostCenterSignUpResponse } from "@/api/type";

export const postCenterSignUp = async(data: PostCenterSignUpRequst
) => {
    try {
        const res = await api.post<ApiResponseType<PostCenterSignUpResponse>>(`/api/web/visitors/centers`, data)
        return res.data;
    } catch (err) {
        console.error("postCenterSignUp API error:", err)
        throw err;
    }
}